import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
// import soinaaTech from ""

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-acem-primary-dark text-white/80 border-t border-white/10 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8 text-sm">
          {/* Col 1 : Association */}
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-white font-title text-lg font-bold">
              <img src="/logo.png" alt="ACEM Logo" className="h-8 w-auto object-contain" />
              <span>ACEM Fès</span>
            </div>
            <p className="text-white/70 text-xs leading-relaxed">
              Association des Comoriens Étudiant au Maroc, section régionale de Fès. Fondée en 2002 pour accompagner, soutenir et fédérer la communauté comorienne.
            </p>
            <p className="text-xs font-bold text-acem-accent">
              Égalité — Solidarité — Excellence
            </p>
            <a href="https://soinaa-tech.com/" target="_blank" rel="noreferrer">
              <img src="/images/soinaaTech.png" alt="SoinaaTech" className="h-10 pt-5 w-auto object-contain" />
            </a>
          </div>

          {/* Col 2 : Espace Études */}
          <div className="space-y-2">
            <h4 className="text-white font-bold text-sm tracking-wider uppercase font-title">Espace Études</h4>
            <ul className="space-y-1.5 text-xs">
              <li><Link to="/etudes/guide-inscription" className="hover:text-white transition-colors">Guide d'inscription</Link></li>
              <li><Link to="/etudes/liste-facultes" className="hover:text-white transition-colors">Liste des facultés</Link></li>
              <li><Link to="/etudes/parcours-universitaires" className="hover:text-white transition-colors">Parcours universitaires</Link></li>
              <li><Link to="/etudes/bibliotheque" className="hover:text-white transition-colors">Bibliothèque PDF</Link></li>
            </ul>
          </div>

          {/* Col 3 : Événements & Social */}
          <div className="space-y-2">
            <h4 className="text-white font-bold text-sm tracking-wider uppercase font-title">Vie Associative</h4>
            <ul className="space-y-1.5 text-xs">
              <li><Link to="/evenements/communiques" className="hover:text-white transition-colors">Communiqués officiels</Link></li>
              <li><Link to="/evenements/calendrier" className="hover:text-white transition-colors">Calendrier annuel</Link></li>
              <li><Link to="/evenements/galerie" className="hover:text-white transition-colors">Galerie Photos</Link></li>
              <li><Link to="/social/entraide" className="hover:text-white transition-colors">Démarches & Solidarité</Link></li>
              <li><Link to="/social/activites-sportives" className="hover:text-white transition-colors">Activités sportives</Link></li>
              <li><Link to="/social/faq" className="hover:text-white transition-colors">Foire aux questions (FAQ)</Link></li>
            </ul>
          </div>

          {/* Col 4 : Réseaux & Recensement */}
          <div className="space-y-3">
            <h4 className="text-white font-bold text-sm tracking-wider uppercase font-title">Rejoindre & Suivre</h4>
            <div className="flex gap-2.5">
              <a
                href="https://www.facebook.com/share/1anbGqXBfc/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#1877F2] text-white flex items-center justify-center transition-all duration-300 shadow-sm"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
              <a
                href="https://www.instagram.com/acem_fes?igsh=MW0yeGswZWtxZGM2Yw=="
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#d62976] text-white flex items-center justify-center transition-all duration-300 shadow-sm"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 0 00-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
              </a>
            </div>
            <div>
              <Link
                to="/inscription"
                className="inline-flex items-center gap-1 text-xs font-bold text-acem-accent hover:underline"
              >
                <span>Recensement des étudiants comoriens</span>
                <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 text-center text-xs text-white/60">
          <p>© {currentYear} ACEM Fès — Association des Comoriens Étudiant au Maroc, section régionale de Fès. </p>
          <p>Développé par IBRAHIM ANAS et <a href="https://soinaa-tech.com/" target="_blank" rel="noreferrer" className="text-acem-accent hover:underline transition-colors duration-300">SOINAA-TECH </a><a href="https://ousseine.netlify.app/" target="_blank" rel="noreferrer" className="text-acem-accent hover:underline transition-colors duration-300"> (OUSSEINE MCHANGAMA HAMDANI) </a>pour l'association. <br />Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
